
import '../App.css';
import useStyles from '../Styles/useStyles'

import React, {Fragment, useState, useEffect} from 'react'

import { useLocation, useHistory } from 'react-router-dom'
import { CssBaseline, Toolbar, Link, AppBar, Typography }
from '@material-ui/core'

import {ArrowBack} from '@material-ui/icons'

const NavBar = (props) => {
    const location = useLocation();
    const history = useHistory();

    useEffect( () => {
    }, [])

    const render = () => {
        return(
            <Fragment>
                <CssBaseline /> 
                <AppBar position="relative">       
                    <Toolbar >
                    <Link onClick={() => { 
                        if (location.pathname === '/lista_boletos') {
                            history.push("/");
                        } 
                        if (location.pathname === '/') {
                            window.history.back();
                        } 
                        if (location.pathname.toString().substr(0, 7) === '/boleto') {
                            history.push("/");
                        }  
                    }}><ArrowBack style={{ color: 'white', marginRight: 10 }} /></Link>
                    <Typography variant="h6" color="inherit" noWrap>JBoletos</Typography>
                    </Toolbar>
                </AppBar>
            </Fragment>
        );
    }

    return(  
        <Fragment>
            {
                //console.log(location.pathname),
                render()
            }
        </Fragment> 
    );
}

export default NavBar